export const USER_ROLES = {
    MASTER_ADMIN: 'master_admin',
    ADMIN: 'admin',
    STAFF: 'staff',
    CUSTOMER: 'customer',
};

export const ADMIN_PANEL_ROLES = [
    USER_ROLES.MASTER_ADMIN,
    USER_ROLES.ADMIN,
    USER_ROLES.STAFF,
];

export function normalizeUserRole(role) {
    const value = String(role || '')
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, '_');

    if (value === 'master_admin') return USER_ROLES.MASTER_ADMIN;
    if (value === USER_ROLES.ADMIN) return USER_ROLES.ADMIN;
    if (value === USER_ROLES.STAFF) return USER_ROLES.STAFF;
    return USER_ROLES.CUSTOMER;
}

export function isAdminPanelRole(role) {
    return ADMIN_PANEL_ROLES.includes(normalizeUserRole(role));
}

export function isMasterAdmin(role) {
    return normalizeUserRole(role) === USER_ROLES.MASTER_ADMIN;
}

export function isStandardAdmin(role) {
    const normalized = normalizeUserRole(role);
    return normalized === USER_ROLES.ADMIN || normalized === USER_ROLES.MASTER_ADMIN;
}

export function getRoleLabel(role) {
    switch (normalizeUserRole(role)) {
        case USER_ROLES.MASTER_ADMIN:
            return 'Master Admin';
        case USER_ROLES.ADMIN:
            return 'Admin';
        case USER_ROLES.STAFF:
            return 'Staff';
        default:
            return 'Customer';
    }
}

export function getDefaultAdminRoute(role) {
    return normalizeUserRole(role) === USER_ROLES.STAFF
        ? '/admin/orders/list'
        : '/admin/dashboard';
}

export function canAccessAdminPath(role, path = '') {
    const normalized = normalizeUserRole(role);
    if (!isAdminPanelRole(normalized)) return false;
    if (normalized !== USER_ROLES.STAFF) return true;

    return path === '/admin'
        || path === '/admin/'
        || path.startsWith('/admin/orders')
        || path.startsWith('/admin/promotions')
        || path === '/admin/settings'
        || path === '/admin/settings/'
        || path.startsWith('/admin/settings/account');
}
